module.exports = __webpack_public_path__ + "media/images/mobile/abouts/16-ef8eecd0e4c93d2d703054205c16c06b.jpg";